import type { FaireProductEntity } from "../../entity_types/product";

export const p_eajrmwsfd7: FaireProductEntity = {
  token: "p_eajrmwsfd7",
  type: "product",
  name: "colorblock long sleeve pocket design blazer coat",
  brandToken: "b_gu26ucey5v",
  brandName: "Queen Fashion",
  imageUrl:
    "https://cdn.faire.com/fastly/2d8b10601bfb8ebe18ede95b2751edaf2247c428b6eea5fea7cd5c0f94376021.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3d51d68b167b478030f3678db20d15dc5fa57ba3bec2cb466e086d69c3c8cf2b.jpeg",
    "https://cdn.faire.com/fastly/36776984730ae4f09a5ae6a29cad9e2b5488fb1f251ca6619354bf50acf7a3a7.jpeg",
    "https://cdn.faire.com/fastly/d87f94503ebb84fec294085eb625ca50b30d3eed5213d06ef69dbac5658e349e.jpeg",
    "https://cdn.faire.com/fastly/3fa357f652b90dda2b63b932e37f6e70df37046d676e87002f4fe34434f54e69.jpeg",
    "https://cdn.faire.com/fastly/63f1f666d92cc0ac6cbf695b2c589b4f1bbbb995743dc795b09fd4c950adb3e4.jpeg",
    "https://cdn.faire.com/fastly/32aa7a4f0697fa330397637280ddc06ad190f37e750a09ae2f552ce571fefb24.jpeg",
    "https://cdn.faire.com/fastly/05fc0111fc39a551a870de9fb5805bd94469b671b6ce3b0c2fc2856df3e63f63.jpeg",
  ],
  priceDollars: 17.32,
  description:
    "colorblock long sleeve pocket design blazer coat\nstyle: elegant\ntype: blazer\nmaterial: polyester\nneckline: notched collar\nsleeve style: long sleeve\nlength: regular\npattern type: colorblock\ndecoration: button\nfit type: regular\noccasion: work",
  tags: [],
  msrpDollars: 31.18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:42.975Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
